import React from 'react'
import { Link } from 'react-router-dom'
import { Smartphone, Mail, Phone, MapPin, Github, Twitter, Linkedin } from 'lucide-react'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  const footerLinks = {
    products: [
      { name: 'CoreTrust手机', path: '/products/coretrust' },
      { name: '熄屏广告系统', path: '/products/ads' },
      { name: '空投助手', path: '/products/airdrop' },
      { name: '数字银行', path: '/products/bank' },
      { name: '硬件钱包', path: '/products/wallet' },
      { name: '应用市场', path: '/products/market' },
      { name: '去中心化通话', path: '/products/call' },
    ],
    company: [
      { name: '关于我们', path: '/about' },
      { name: '新闻中心', path: '/news' },
      { name: '投资合作', path: '/investment' },
      { name: '人才招聘', path: '/careers' },
      { name: '联系我们', path: '/contact' },
    ],
    support: [
      { name: '帮助中心', path: '/help' },
      { name: '技术文档', path: '/docs' },
      { name: 'API文档', path: '/api' },
      { name: '开发者社区', path: '/community' },
      { name: '用户反馈', path: '/feedback' },
    ],
    legal: [
      { name: '隐私政策', path: '/privacy' },
      { name: '服务条款', path: '/terms' },
      { name: 'Cookie政策', path: '/cookies' },
      { name: '法律声明', path: '/legal' },
    ],
  }

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <Smartphone className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold">DeepLink</span>
            </div>
            <p className="text-gray-400 mb-4">
              专注于Web3深度集成的硬件设备制造商，提供完整的Web3生态系统解决方案。
            </p>
            <p className="text-lg font-semibold text-blue-400 mb-2">
              转账别害怕，地址打电话
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Github className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-semibold mb-4">产品</h3>
            <ul className="space-y-2">
              {footerLinks.products.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-4">公司</h3>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-4">支持</h3>
            <ul className="space-y-2">
              {footerLinks.support.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">法律</h3>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex items-center space-x-3">
              <Mail className="w-5 h-5 text-blue-400" />
              <div>
                <p className="text-sm text-gray-400">邮箱</p>
                <p className="text-white">contact@deeplink.hk</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <Phone className="w-5 h-5 text-blue-400" />
              <div>
                <p className="text-sm text-gray-400">电话</p>
                <p className="text-white">+852 1234-5678</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <MapPin className="w-5 h-5 text-blue-400" />
              <div>
                <p className="text-sm text-gray-400">地址</p>
                <p className="text-white">香港中环国际金融中心二期</p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © {currentYear} DeepLink Limited. 保留所有权利。
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer